import React from "react"
import styled, {css} from "styled-components"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {BottomSheet} from "./BottomSheet"
import {FilterContent} from "./FilterContent"
import {HelpContent} from "./HelpContent"

export const MobileSearchBar = () => {
  return (
    <SearchContainer>
      <SearchWrapper>
        <Icon icon={IconTypes.search} size={24} />
        {/* dummy search bar, non functional */}
        <SearchInput placeholder="Search brand or keyword" />
      </SearchWrapper>
      <IconsWrapper>
        <BottomSheet icon={IconTypes.filter1}>
          <FilterContent />
        </BottomSheet>
        <BottomSheet icon={IconTypes.help}>
          <HelpContent />
        </BottomSheet>
      </IconsWrapper>
    </SearchContainer>
  )
}

const SearchContainer = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.two};
    background: ${theme.colors.greys.white};
    display: flex;
    align-items: center;
    gap: ${theme.spacing.two};
  `}
`

const SearchWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    background: ${theme.colors.greys.lightest};
    border-radius: 100px;
    padding: ${theme.spacing.one} ${theme.spacing.two};
    gap: ${theme.spacing.one};
    flex: 1;
  `}
`

const SearchInput = styled.input`
  ${({theme}) => css`
    border: none;
    background: transparent;
    width: 100%;
    font-size: 14px;
    outline: none;
    &::placeholder {
      color: ${theme.colors.greys.mediumDark};
    }
  `}
`

const IconsWrapper = styled.div`
  ${({theme}) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.oneAndHalf};
  `}
`
